export default __webpack_public_path__ + "static/aws-logo-36a10ced86680c7d24c5575b235307a9.svg";